import { LitElement, html, css } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import type { LabelledCircleAttributes } from 'zaptic-labelled-circle'

/**
 * Used to place a label inside a circle in a way that will center well at any size
 * This is accomplished by using an svg to set the text
 */
@customElement('zaptic-labelled-circle')
export class LabelledCircle extends LitElement implements LabelledCircleAttributes {
    static styles = css`
        :host {
            display: block;
            width: var(--LabelledCircle-size);
            color: var(--LabelledCircle-backgroundColor);
            aspect-ratio: 1/1;
        }

        svg {
            width: 100%;
            height: 100%;
            font-weight: var(--font-weight-bold);
        }

        svg > text {
            fill: var(--LabelledCircle-textColor);
            letter-spacing: -0.025em;
        }
    `

    @property({ reflect: true })
    label = ''

    @property({ attribute: 'font-size', reflect: true })
    fontSize = 0

    render() {
        const fontSize = this.fontSize || calculateFontSizeToFit(this.label)
        return html`<svg viewBox="0 0 100 100" display="block">
            <circle cx="50" cy="50" r="50" fill="currentColor" />
            <text x="50" y="56.5" dominant-baseline="middle" text-anchor="middle" font-size="${fontSize}px">
                ${this.label}
            </text>
        </svg>`
    }
}

/**
 * Exponential decay to calculate a shrinking size between 10px and 75px
 */
function calculateFontSizeToFit(label: string) {
    return 10 + 65 * Math.pow(0.7, label.length - 1)
}
